module.exports = __webpack_public_path__ + "static/img/place.a7c310e8.svg";